import { Image, StyleSheet, TextInput, TouchableOpacity, View } from "react-native"
import { color_333333, color_BEBEBE, color_EEF2F9, color_main, white } from "../../../assets/style/colors"
export type ChatSearchInputProps = {
    searchText: string;
    onChangeText: (text: string) => void;
}
export const ChatSearchInput = ({ searchText, onChangeText }: ChatSearchInputProps) => {

    return (<View
        style={[
            styles.inputBg,
            {
                backgroundColor: white,
                borderWidth: 1,
                borderColor: searchText.length > 0 ? color_main : "#E0E0E0",
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 2,
                elevation: 1,
            },
        ]}
    >
        <Image
            source={require("../../../assets/image/icon_search.png")}
            style={{ width: 20, height: 20, objectFit: "contain", marginEnd: 8 }} />
        <TextInput
            editable={true}
            focusable={true}
            autoFocus={true}
            selectionColor={color_main}
            placeholderTextColor={color_BEBEBE}
            style={[styles.input]}
            value={searchText}
            returnKeyType={"done"}
            onChangeText={onChangeText}
        />
        {searchText.length > 0 && (
            <TouchableOpacity
                activeOpacity={0.7}
                onPress={() => {
                    onChangeText("");
                }}
                style={{
                    height: 40,
                    justifyContent: "center",
                    alignItems: "center",
                    paddingHorizontal: 12,
                }}
            >
                <Image
                    source={require("../../../assets/image/icon_del.png")}
                    style={{ width: 18, height: 18, opacity: 0.6 }}
                />
            </TouchableOpacity>
        )}
    </View>)
}

const styles = StyleSheet.create({
    inputBg: {
        flexDirection: "row",
        backgroundColor: color_EEF2F9,
        borderRadius: 10,
        alignItems: "center",
        height: 50,
        paddingHorizontal: 16,
        marginHorizontal: 20,
        marginTop: 4,
        minHeight: 50,
    },
    input: {
        height: 50,
        flex: 1,
        color: color_333333,
        fontSize: 16,
        marginStart: 8,
    }
})